import axios from '../utils/request'
//列表
export const librarysList = (data) => axios.post('doc/collect_list', data)  

//cid 
export const getcid = (data) => axios.post('mpsucker/catelist', data)      